(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amavya-accueil-defilant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (evenement) {
    var bouton = evenement.target.closest ? evenement.target.closest('[data-riv-pause]') : null;
    if (!bouton) return;
    var section = bouton.closest('[data-riv-defil]');
    if (!section) return;
    var enPause = section.classList.toggle('est-en-pause');
    var texte = bouton.querySelector('[data-riv-pause-texte]');
    if (texte) texte.textContent = enPause ? 'Relancer le défilement' : 'Mettre en pause';
  });

  (function () {
    var calme = window.matchMedia('(prefers-reduced-motion: reduce)');
    var souris = window.matchMedia('(hover: hover) and (pointer: fine)');

    function brancher(section) {
      if (section.dataset.rivBranche) return;
      section.dataset.rivBranche = '1';
      var cible = { x: 0.5, y: 0.5 };
      var actuel = { x: 0.5, y: 0.5 };
      var dedans = false;
      var visible = true;
      var depart = performance.now();
      var boucle = null;

      function image(temps) {
        boucle = null;
        if (calme.matches) {
          section.style.setProperty('--mx', '0.5');
          section.style.setProperty('--my', '0.5');
          return;
        }
        if (!dedans) {
          var s = (temps - depart) / 1000;
          cible.x = 0.5 + 0.32 * Math.sin(s / 3.2);
          cible.y = 0.5 + 0.18 * Math.cos(s / 4.1);
        }
        actuel.x += (cible.x - actuel.x) * 0.06;
        actuel.y += (cible.y - actuel.y) * 0.06;
        section.style.setProperty('--mx', actuel.x.toFixed(4));
        section.style.setProperty('--my', actuel.y.toFixed(4));
        if (visible) boucle = requestAnimationFrame(image);
      }

      function relancer() {
        if (!boucle && visible && !calme.matches) boucle = requestAnimationFrame(image);
      }

      section.addEventListener('pointermove', function (evenement) {
        if (!souris.matches) return;
        var cadre = section.getBoundingClientRect();
        cible.x = Math.min(1, Math.max(0, (evenement.clientX - cadre.left) / cadre.width));
        cible.y = Math.min(1, Math.max(0, (evenement.clientY - cadre.top) / cadre.height));
        section.style.setProperty('--px', (evenement.clientX - cadre.left).toFixed(0) + 'px');
        section.style.setProperty('--py', (evenement.clientY - cadre.top).toFixed(0) + 'px');
        if (!dedans) {
          dedans = true;
          section.classList.add('est-survole');
        }
        relancer();
      });

      section.addEventListener('pointerleave', function () {
        dedans = false;
        section.classList.remove('est-survole');
        depart = performance.now();
        relancer();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entrees) {
          visible = entrees[0].isIntersecting;
          if (visible) relancer();
        }).observe(section);
      }
      if (calme.addEventListener) calme.addEventListener('change', relancer);
      relancer();

      var aimant = section.querySelector('[data-riv-aimant]');
      if (aimant) {
        aimant.addEventListener('pointermove', function (evenement) {
          if (!souris.matches || calme.matches) return;
          var cadre = aimant.getBoundingClientRect();
          aimant.style.setProperty('--aimant-x', ((evenement.clientX - cadre.left - cadre.width / 2) * 0.18).toFixed(1) + 'px');
          aimant.style.setProperty('--aimant-y', ((evenement.clientY - cadre.top - cadre.height / 2) * 0.28).toFixed(1) + 'px');
        });
        aimant.addEventListener('pointerleave', function () {
          aimant.style.setProperty('--aimant-x', '0px');
          aimant.style.setProperty('--aimant-y', '0px');
        });
      }
    }

    function brancherTout() {
      document.querySelectorAll('[data-riv-defil]').forEach(brancher);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancherTout);
    else brancherTout();
    document.addEventListener('shopify:section:load', brancherTout);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amavya-maison-antibes"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var mouvementReduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function entrer(t) { return t * t * t; }
    function sortir(t) { return 1 - Math.pow(1 - t, 3); }
    function assouplir(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

    function couverture(img, W, H) {
      var e = Math.max(W / img.naturalWidth, H / img.naturalHeight);
      var sw = W / e, sh = H / e;
      return [(img.naturalWidth - sw) / 2, (img.naturalHeight - sh) / 2, sw, sh];
    }

    function pret(img) {
      if (!img) return Promise.resolve(null);
      if (img.complete && img.naturalWidth) return Promise.resolve(img);
      img.loading = 'eager';
      return new Promise(function (ok) {
        img.addEventListener('load', function () { ok(img); }, { once: true });
        img.addEventListener('error', function () { ok(null); }, { once: true });
      });
    }

    function reduire(img, W, H, b, tampon) {
      var w = Math.max(1, Math.ceil(W / b)), h = Math.max(1, Math.ceil(H / b));
      tampon.width = w;
      tampon.height = h;
      var t = tampon.getContext('2d');
      var c = couverture(img, W, H);
      t.imageSmoothingEnabled = true;
      t.drawImage(img, c[0], c[1], c[2], c[3], 0, 0, w, h);
      return [w, h];
    }

    function agrandir(ctx, tampon, g, b) {
      ctx.imageSmoothingEnabled = false;
      ctx.drawImage(tampon, 0, 0, g[0], g[1], 0, 0, g[0] * b, g[1] * b);
    }

    function net(ctx, img, W, H) {
      var c = couverture(img, W, H);
      ctx.imageSmoothingEnabled = true;
      ctx.drawImage(img, c[0], c[1], c[2], c[3], 0, 0, W, H);
    }

    function Maison(racine) {
      var diapos = [].slice.call(racine.querySelectorAll('[data-amv-diapo]'));
      if (diapos.length < 2 || racine.getAttribute('data-amv-pret')) return;
      racine.setAttribute('data-amv-pret', '1');
      racine.classList.add('js-pret');

      var cadre = racine.querySelector('[data-amv-cadre]');
      var toile = racine.querySelector('[data-amv-pixels]');
      var ctx = toile.getContext('2d');
      var tampon = document.createElement('canvas');
      var tamponSuivant = document.createElement('canvas');
      var num = racine.querySelector('[data-amv-num]');
      var boutonPause = racine.querySelector('[data-amv-pause]');
      var duree = Math.max(3, parseFloat(racine.getAttribute('data-duree')) || 6) * 1000;
      var actuel = 0, enCours = false, pauseVoulue = mouvementReduit, visible = false, minuteur = null;

      function image(i) { return diapos[i].querySelector('img'); }

      function montrer(i) {
        diapos.forEach(function (d, k) {
          d.classList.toggle('est-active', k === i);
          if (k === i) d.removeAttribute('aria-hidden');
          else d.setAttribute('aria-hidden', 'true');
        });
        actuel = i;
        if (num) num.textContent = String(i + 1);
        pret(image((i + 1) % diapos.length));
      }

      function arreterMinuteur() {
        if (minuteur) { clearTimeout(minuteur); minuteur = null; }
      }

      function planifier() {
        arreterMinuteur();
        if (pauseVoulue || !visible || document.hidden) return;
        minuteur = setTimeout(function () { aller(actuel + 1); }, duree);
      }

      function transition(depart, arrivee, i) {
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        var W = Math.round(cadre.clientWidth * dpr), H = Math.round(cadre.clientHeight * dpr);
        var B = Math.max(8, Math.round(Math.min(W, H) / 22));
        var T1 = 650, T2 = 750, T3 = 650;
        var debut = null, cellules = null, grille = null, dessinees = 0;
        toile.width = W;
        toile.height = H;
        toile.classList.add('est-visible');

        function etape(maintenant) {
          if (debut === null) debut = maintenant;
          var t = maintenant - debut;
          if (t < T1) {
            var b1 = Math.round(1 + (B - 1) * entrer(t / T1));
            ctx.clearRect(0, 0, W, H);
            if (b1 < 2) net(ctx, depart, W, H);
            else agrandir(ctx, tampon, reduire(depart, W, H, b1, tampon), b1);
          } else if (t < T1 + T2) {
            if (!cellules) {
              ctx.clearRect(0, 0, W, H);
              agrandir(ctx, tampon, reduire(depart, W, H, B, tampon), B);
              grille = reduire(arrivee, W, H, B, tamponSuivant);
              cellules = [];
              for (var k = 0; k < grille[0] * grille[1]; k++) cellules.push(k);
              for (var m = cellules.length - 1; m > 0; m--) {
                var r = Math.floor(Math.random() * (m + 1));
                var x = cellules[m]; cellules[m] = cellules[r]; cellules[r] = x;
              }
              ctx.imageSmoothingEnabled = false;
            }
            var cible = Math.floor(cellules.length * assouplir((t - T1) / T2));
            for (; dessinees < cible; dessinees++) {
              var n = cellules[dessinees], cx = n % grille[0], cy = (n / grille[0]) | 0;
              ctx.drawImage(tamponSuivant, cx, cy, 1, 1, cx * B, cy * B, B, B);
            }
          } else if (t < T1 + T2 + T3) {
            var b3 = Math.round(B - (B - 1) * sortir((t - T1 - T2) / T3));
            ctx.clearRect(0, 0, W, H);
            if (b3 < 2) net(ctx, arrivee, W, H);
            else agrandir(ctx, tampon, reduire(arrivee, W, H, b3, tampon), b3);
          } else {
            montrer(i);
            toile.classList.remove('est-visible');
            ctx.clearRect(0, 0, W, H);
            enCours = false;
            planifier();
            return;
          }
          window.requestAnimationFrame(etape);
        }
        window.requestAnimationFrame(etape);
      }

      function aller(i) {
        if (enCours) return;
        i = (i + diapos.length) % diapos.length;
        if (i === actuel) return;
        arreterMinuteur();
        if (mouvementReduit) { montrer(i); planifier(); return; }
        enCours = true;
        Promise.all([pret(image(actuel)), pret(image(i))]).then(function (imgs) {
          if (!imgs[0] || !imgs[1]) { montrer(i); enCours = false; planifier(); return; }
          transition(imgs[0], imgs[1], i);
        });
      }

      racine.querySelector('[data-amv-suiv]').addEventListener('click', function () { aller(actuel + 1); });
      racine.querySelector('[data-amv-prec]').addEventListener('click', function () { aller(actuel - 1); });
      if (boutonPause) {
        boutonPause.addEventListener('click', function () {
          pauseVoulue = !pauseVoulue;
          boutonPause.textContent = pauseVoulue ? 'Relancer le diaporama' : 'Mettre en pause';
          planifier();
        });
      }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entrees) {
          visible = entrees[0].isIntersecting;
          planifier();
        }, { threshold: 0.35 }).observe(cadre);
      } else {
        visible = true;
        planifier();
      }
      document.addEventListener('visibilitychange', planifier);
      pret(image(1));
    }

    function demarrer(portee) {
      [].forEach.call((portee || document).querySelectorAll('[data-amv-maison]'), Maison);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { demarrer(); });
    } else {
      demarrer();
    }
    document.addEventListener('shopify:section:load', function (evenement) { demarrer(evenement.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["amavya-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function lancerVideos() {
      var calme = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      document.querySelectorAll('[data-amv-page-immersive] video').forEach(function (video) {
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        if (calme) {
          video.removeAttribute('autoplay');
          video.pause();
          return;
        }
        video.controls = false;
        video.removeAttribute('controls');
        video.setAttribute('webkit-playsinline', '');
        if (video.dataset.amvLecture) return;
        video.dataset.amvLecture = '1';
        video.addEventListener('playing', function () {
          video.classList.add('est-en-lecture');
        });
        if (!video.paused && video.readyState > 2) video.classList.add('est-en-lecture');
        essayerLecture(video);
      });
    }

    var videosEnAttente = [];
    var gestes = ['click', 'touchend', 'keydown'];

    function essayerLecture(video) {
      var lecture = video.play();
      if (lecture && lecture.catch) {
        lecture.catch(function () {
          attendreGeste(video);
        });
      }
    }

    function relancerApresGeste() {
      var videos = videosEnAttente;
      videosEnAttente = [];
      gestes.forEach(function (type) {
        document.removeEventListener(type, relancerApresGeste, true);
      });
      videos.forEach(essayerLecture);
    }

    function attendreGeste(video) {
      if (videosEnAttente.indexOf(video) !== -1) return;
      if (!videosEnAttente.length) {
        gestes.forEach(function (type) {
          document.addEventListener(type, relancerApresGeste, true);
        });
      }
      videosEnAttente.push(video);
    }

    function brancherDeroule(colonne) {
      if (colonne.dataset.amvBranche) return;
      colonne.dataset.amvBranche = '1';
      var entete = colonne.querySelector('[data-amv-deroule-entete]');
      var bouton = colonne.querySelector('[data-amv-deroule-bouton]');
      var texte = colonne.querySelector('[data-amv-deroule-texte]');
      var interieur = colonne.querySelector('.amv-page__corps-interieur');
      if (!entete || !bouton || !texte || !interieur) return;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          colonne.classList.remove('amv-sans-transition');
        });
      });
      entete.addEventListener('click', function (evenement) {
        if (evenement.target.closest('a')) return;
        var ouvrir = colonne.classList.contains('est-replie');
        colonne.classList.toggle('est-replie', !ouvrir);
        bouton.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
        texte.textContent = colonne.getAttribute(ouvrir ? 'data-libelle-fermer' : 'data-libelle-ouvrir');
        if (ouvrir) interieur.removeAttribute('inert');
        else interieur.setAttribute('inert', '');
      });
    }

    function lancer() {
      lancerVideos();
      document.querySelectorAll('[data-amv-deroule]').forEach(brancherDeroule);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', lancer);
    else lancer();
    document.addEventListener('shopify:section:load', lancer);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
